import { ApiService } from '@allbin/viu-api-client';

export const reviveService = (service: ApiService): Service => ({
  ...service,
});

export type Service = ApiService;
